export enum FeatureFlagEvents {
  CHANGE = '@zageno/feature-flag:change',
}
